var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 601,
    height: 729,
    viewBox: "0 0 601 729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17154",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17154",
    transform: "translate(13318.369 6847.028)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15312",
    "data-name": "\\u9577\\u65B9\\u5F62 15312",
    width: 601,
    height: 710,
    transform: "translate(-13318.369 -6847.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15313",
    "data-name": "\\u9577\\u65B9\\u5F62 15313",
    width: 75,
    height: 30,
    rx: 15,
    transform: "translate(-13318.369 -6816.028)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15314",
    "data-name": "\\u9577\\u65B9\\u5F62 15314",
    width: 75,
    height: 30,
    rx: 15,
    transform: "translate(-13318.369 -6619.028)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17134",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17134",
    transform: "translate(-13295.643 -6769.051)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(2.273 89.022)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(0.273 0.022)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17139",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17139",
    transform: "translate(-13295.643 -6568.403)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-2",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(2.273 89.374)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-2",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(0.273 0.374)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17144",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17144",
    transform: "translate(-13295.643 -6434.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-3",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(2.273 89.128)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-3",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(0.273 0.128)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17149",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17149",
    transform: "translate(-13295.643 -6299.911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-4",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 16,
    rx: 8,
    transform: "translate(2.273 89.882)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-4",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(0.273 -0.118)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17135",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17135",
    transform: "translate(-13179.44 -6769.051)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-5",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(2.071 89.022)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-5",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(0.071 0.022)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17140",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17140",
    transform: "translate(-13179.44 -6568.403)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-6",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(2.071 89.374)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-6",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(0.071 0.374)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17145",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17145",
    transform: "translate(-13179.44 -6434.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-7",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(2.071 89.128)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-7",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(0.071 0.128)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17150",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17150",
    transform: "translate(-13179.44 -6299.911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-8",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 16,
    rx: 8,
    transform: "translate(2.071 89.882)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-8",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(0.071 -0.118)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17136",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17136",
    transform: "translate(-13060.351 -6768.329)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-9",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.981 89.3)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-9",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.019 0.3)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17141",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17141",
    transform: "translate(-13060.351 -6567.681)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-10",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 16,
    rx: 8,
    transform: "translate(1.981 89.653)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5105-10",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41.5,
    rx: 41,
    ry: 41.5,
    transform: "translate(-0.019 -0.347)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17146",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17146",
    transform: "translate(-13060.351 -6433.435)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-11",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.981 89.406)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-11",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.019 0.407)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17151",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17151",
    transform: "translate(-13060.351 -6299.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-12",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.981 89.16)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-12",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.019 0.16)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17137",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17137",
    transform: "translate(-12941.262 -6768.329)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-13",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.893 89.3)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-13",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.107 0.3)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17142",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17142",
    transform: "translate(-12941.262 -6567.681)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-14",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 16,
    rx: 8,
    transform: "translate(1.893 89.653)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5105-14",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41.5,
    rx: 41,
    ry: 41.5,
    transform: "translate(-0.107 -0.347)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17147",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17147",
    transform: "translate(-12941.262 -6433.435)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-15",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.893 89.406)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-15",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.107 0.407)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17152",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17152",
    transform: "translate(-12941.262 -6299.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-16",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.893 89.16)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-16",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.107 0.16)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17138",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17138",
    transform: "translate(-12822.172 -6768.329)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-17",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.803 89.3)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-17",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.197 0.3)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17143",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17143",
    transform: "translate(-12822.172 -6567.681)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-18",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 16,
    rx: 8,
    transform: "translate(1.803 89.653)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5105-18",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41.5,
    rx: 41,
    ry: 41.5,
    transform: "translate(-0.197 -0.347)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17148",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17148",
    transform: "translate(-12822.172 -6433.435)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-19",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.803 89.406)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-19",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.197 0.407)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17153",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17153",
    transform: "translate(-12822.172 -6299.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15315-20",
    "data-name": "\\u9577\\u65B9\\u5F62 15315",
    width: 79,
    height: 17,
    rx: 8.5,
    transform: "translate(1.803 89.16)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5105-20",
    "data-name": "\\u6955\\u5186\\u5F62 5105",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(-0.197 0.16)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15316",
    "data-name": "\\u9577\\u65B9\\u5F62 15316",
    width: 601,
    height: 256,
    transform: "translate(-13318.369 -6374.028)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListholder);
export default __webpack_public_path__ + "static/media/listholder.95a28f55137fa3abff53e9ce92d036a1.svg";
export { ForwardRef as ReactComponent };